let statusTimeout;

if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initForms);
} else {
    initForms();
}

function initForms() {
    var companyForm = document.getElementById("companyForm");
    var workplaceForms = document.querySelectorAll('.workplace-form');
    var loginForm = document.getElementById("loginForm");
    var generatePdfForm = document.getElementById("generatePdfForm");
    var statusBar = document.getElementById('form-status-bar');

    // default login failed behaviour, as it is triggered by viewdata and not a data response due to unexpected errors
    if (statusBar) {
        setTimeout(() => {
            statusBar.classList.remove('form-status-bar--visible');
        }, 3000)
    }

    SetFormBehaviour(companyForm);
    SetFormBehaviour(loginForm);
    SetFormBehaviour(generatePdfForm);

    workplaceForms.forEach(form => {
        SetFormBehaviour(form);
    });
}

async function SetFormBehaviour(form) {
    if (form === null || form === undefined) return;

    form.addEventListener("submit", async function (e) {
        e.preventDefault();

        const form = e.target;
        const formData = new FormData(form);

        try {
            const response = await fetch(form.action, {
                method: "POST",
                body: formData
            });

            const contentDisposition =
                response.headers.get("Content-Disposition");

            if (response.ok && contentDisposition?.includes("attachment")) {
                const blob = await response.blob();

                const downloadUrl = URL.createObjectURL(blob);
                const link = document.createElement("a");

                link.href = downloadUrl;
                link.download = getFilename(response) ?? "download";

                document.body.appendChild(link);
                link.click();
                link.remove();

                URL.revokeObjectURL(downloadUrl);

                return;
            }

            const result = await response.text();

            if (isValidUrl(result)) {
                window.location.href = result;
            }
            else {
                ShowStatusMessage(result, response.ok);
            }
        }
        catch (err) {
            console.error(err);
            ShowStatusMessage(err.message);
        }
    });
}

function getFilename(response) {
    const disposition = response.headers.get("Content-Disposition");

    if (!disposition) {
        return null;
    }

    const match = disposition.match(
        /filename\*?=(?:UTF-8''|")?([^";]+)/
    );

    return match
        ? decodeURIComponent(match[1])
        : null;
}

function ShowStatusMessage(message, success = false, duration = 3000) {
    const statusBar = document.getElementById('form-status-bar');

    clearTimeout(statusTimeout);

    statusBar.textContent = message;
    statusBar.classList.remove(
        'form-status-bar--success',
        'form-status-bar--error'
    );

    statusBar.classList.add(
        success
            ? 'form-status-bar--success'
            : 'form-status-bar--error'
    );

    statusBar.classList.add('form-status-bar--visible');

    statusTimeout = setTimeout(() => {
        statusBar.classList.remove('form-status-bar--visible');
    }, duration);
}

function isValidUrl(value) {
    if (typeof value !== "string" || !value.trim()) {
        return false;
    }

    if (value.startsWith("/")) {
        return true;
    }

    try {
        const url = new URL(value);
        return ["http:", "https:"].includes(url.protocol);
    } catch {
        return false;
    }
}
